export function isAudioRecordingSupported() {
    if (typeof window === "undefined") {
        return false;
    }

    return typeof window.MediaRecorder !== "undefined"
        && Boolean(navigator?.mediaDevices?.getUserMedia);
}

export async function resumeAudioContextIfNeeded(audioContext) {
    if (!audioContext || audioContext.state !== "suspended") {
        return;
    }

    await audioContext.resume();
}

export async function createAudioProcessingGraph(stream) {
    const AudioContextCtor = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextCtor) {
        return {
            analyser: null,
            audioContext: null,
            sourceNode: null,
        };
    }

    const audioContext = new AudioContextCtor();
    await resumeAudioContextIfNeeded(audioContext);

    const sourceNode = audioContext.createMediaStreamSource(stream);
    const analyser = audioContext.createAnalyser();
    analyser.fftSize = 1024;
    analyser.minDecibels = -90;
    analyser.maxDecibels = -10;
    analyser.smoothingTimeConstant = 0.65;

    sourceNode.connect(analyser);

    return {
        analyser,
        audioContext,
        sourceNode,
    };
}

export async function requestRecorderData(recorder, timeoutMs) {
    if (!recorder || recorder.state === "inactive") {
        return;
    }

    await new Promise((resolve) => {
        let settled = false;
        const handleDataAvailable = () => {
            finish();
        };
        const finish = () => {
            if (settled) {
                return;
            }

            settled = true;
            clearTimeout(timeoutId);
            recorder.removeEventListener("dataavailable", handleDataAvailable);
            resolve();
        };
        const timeoutId = window.setTimeout(finish, timeoutMs);

        recorder.addEventListener("dataavailable", handleDataAvailable, { once: true });

        try {
            recorder.requestData();
        } catch (error) {
            finish();
        }
    });
}

export async function stopMediaRecorder(recorder) {
    if (!recorder || recorder.state === "inactive") {
        return;
    }

    await new Promise((resolve) => {
        recorder.addEventListener("stop", resolve, { once: true });
        recorder.stop();
    });
}
